import React, { useState } from 'react';
import MenuTable from './MenuTable';
import {useSelector,useDispatch} from 'react-redux'
import axios from 'axios'
import gif from './loading.gif'




function Programm (props){

const data = useSelector(state => state.events)
const dispatch = useDispatch()
const [load,setLoad] = useState(false)




function getData (){
  axios.get(`/?id=WIrbis&action=Conference/GetDaysEventsJSON&sid=${props.sid}`).then((resp) => {
    dispatch ({type:'TABLE_LOAD_TABLES',payload: resp.data})
    setLoad(true)
    console.log(resp.data) 
 
    
})
}



    if (load === false){
       return (<div className='loading'><img onLoad={getData()} src={gif} width='100' height='100'/> </div>)
    }
    return(
        <div className='information'>
           
            {
                data.RecList.map(
                    (title, index) => <MenuTable title = {title.title} key = {index} data={data} id ={title.id}/>
                )
            }
             



        </div>





    );






}


export default Programm